import React, { useEffect, useRef, useState } from 'react';

const Hero = ({ t, lang }) => {
  const isRtl = lang === 'ar';
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  
  const videoSrc = process.env.PUBLIC_URL + "/videos/YAM INTERNATIONAL.mp4";
  const posterSrc = "./images/1.webp"; 

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const forcePlay = () => {
      video.play().then(() => {
        setIsLoaded(true);
      }).catch(() => {
        // في حال فشل التشغيل التلقائي (بسبب قيود المتصفح)
        console.log("Autoplay prevented");
      });
    };

    video.addEventListener('loadeddata', forcePlay);
    forcePlay();
    document.addEventListener('touchstart', forcePlay, { once: true });

    return () => {
      video.removeEventListener('loadeddata', forcePlay);
      document.removeEventListener('touchstart', forcePlay);
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.pageYOffset - 70,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero-wrap" style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      
      {/* 1. تحسين الـ LCP: استخدام عنصر img بدلاً من Background Image */}
      <img 
        src={posterSrc} 
        alt="Yam International Hero" 
        className="hero-poster-static"
        fetchPriority="high" 
        loading="eager"
      />

      {/* 2. تحسين تحميل الفيديو */}
      <video 
        ref={videoRef}
        autoPlay 
        muted 
        loop 
        playsInline 
        webkit-playsinline="true"
        preload="metadata" 
        poster={posterSrc}
        className={`hero-video ${isLoaded ? 'active' : ''}`}
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      <div className="hero-overlay">
        <div className="container-limited">
          <div className="hero-text-content">
            <h1 className="hero-h1">
              {t?.hero?.title}
            </h1>
            
            <p className="hero-p">
              {t?.hero?.sub}
            </p>

            <div className="hero-btns">
              {/* 3. تحسين الـ Accessibility: إضافة aria-label */}
              <button 
                onClick={() => scrollToSection('yamshop')} 
                className="btn-gold"
                aria-label={t?.hero?.btn || "Go to shop"}
              >
                {t?.hero?.btn}
              </button>
              <button 
                onClick={() => scrollToSection('about')} 
                className="btn-outline"
                aria-label={t?.nav?.about || "About us"}
              >
                {t?.nav?.about}
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .hero-wrap {
          height: 100vh;
          min-height: 600px;
          position: relative;
          overflow: hidden;
          background-color: #050a12;
          display: flex;
          align-items: center;
        }

        /* تعديل الـ CSS ليتناسب مع عنصر img */
        .hero-poster-static {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          object-fit: cover;
          z-index: 0;
        }

        .hero-video {
          position: absolute;
          top: 50%; left: 50%;
          min-width: 100%; min-height: 100%;
          width: auto; height: auto;
          transform: translate(-50%, -50%) scale(1.02);
          object-fit: cover;
          z-index: 1;
          opacity: 0;
          transition: opacity 1.2s ease-in-out;
        }

        .hero-video.active { opacity: 1; }

        .hero-overlay {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(13, 31, 51, 0.55);
          z-index: 2;
          display: flex;
          align-items: center;
        }

        .hero-text-content {
          position: relative;
          z-index: 3;
          max-width: 900px;
          color: white;
          text-align: ${isRtl ? 'right' : 'left'};
          padding: 0 7%;
        }

        .hero-h1 { 
          font-size: clamp(2rem, 5.5vw, 4rem); 
          font-weight: 900; 
          line-height: 1.2; 
          margin-bottom: 20px; 
          font-family: 'Cairo', sans-serif !important; 
        }

        .hero-p { 
          color: #d4af37; 
          font-size: clamp(1rem, 2vw, 1.4rem); 
          font-weight: 600; 
          line-height: 1.6;
          margin-bottom: 40px; 
          font-family: 'Cairo', sans-serif !important; 
          max-width: 800px;
        }

        .hero-btns { display: flex; gap: 20px; }
        
        .btn-gold { 
          background: #d4af37; 
          color: #0d1f33; 
          border: none; 
          padding: 16px 40px; 
          border-radius: 50px; 
          font-weight: 900; 
          font-size: 1rem; 
          cursor: pointer; 
          transition: 0.3s; 
          font-family: 'Cairo', sans-serif !important; 
        }

        .btn-gold:hover { background: #f1c40f; transform: translateY(-2px); }

        .btn-outline { 
          background: transparent; 
          color: white; 
          border: 2px solid white; 
          padding: 14px 40px; 
          border-radius: 50px; 
          font-weight: 900; 
          font-size: 1rem; 
          cursor: pointer; 
          transition: 0.3s; 
          font-family: 'Cairo', sans-serif !important; 
        }

        .btn-outline:hover { background: white; color: #0d1f33; transform: translateY(-2px); }

        @media (max-width: 768px) {
          .hero-text-content { text-align: center; padding: 0 20px; }
          .hero-btns { justify-content: center; flex-direction: column; align-items: center; }
          .btn-gold, .btn-outline { width: 100%; max-width: 280px; }
          .hero-h1 { font-size: 2.2rem; }
          .hero-p { font-size: 1.1rem; }
        }
      `}</style>
    </section>
  );
};

export default Hero;